function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate9865117(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.964 511.964",
    style: {
      enableBackground: "new 0 0 511.964 511.964"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M404.324,53.262h93.14c3.866,0,7,3.134,7,7v296.33c0,3.866-3.134,7-7,7H155.022"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M38.487,252.087V60.262c0-3.866,3.134-7,7-7h326.151"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M473.402,273.305v29.225c-16.569,0-30,13.431-30,30H163.037"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M69.549,229.396V114.324c16.569,0,30-13.431,30-30h343.853c0,16.569,13.431,30,30,30v126.294"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 162.779,
    y1: 192.749,
    x2: 380.215,
    y2: 192.749
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 162.779,
    y1: 223.812,
    x2: 380.215,
    y2: 223.812
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 193.842,
    y1: 254.874,
    x2: 349.153,
    y2: 254.874
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M334.366,145.864h-125.78c-3.866,0-7-3.134-7-7v-17.062c0-3.866,3.134-7,7-7h125.78c3.866,0,7,3.134,7,7v17.062 C341.366,142.73,338.232,145.864,334.366,145.864z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 411.277,
    y1: 301.467,
    x2: 364.684,
    y2: 301.467
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 145.147,364.849 181.784,434.883 144.619,419.269 136.251,458.702 96.063,381.878 \t\t\t"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 44.214,364.7 7.5,434.883 44.665,419.269 53.033,458.702 93.278,381.77 \t\t\t"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M178.234,309.32c0,8.412-12.284,14.78-14.749,22.37c-2.554,7.867,3.552,20.222-1.213,26.77 c-4.813,6.613-18.483,4.599-25.096,9.412c-6.548,4.765-8.83,18.414-16.696,20.968c-7.59,2.465-17.425-7.156-25.837-7.156 c-8.412,0-18.247,9.62-25.837,7.156c-7.867-2.554-10.149-16.203-16.697-20.969c-6.613-4.813-20.283-2.799-25.096-9.413 c-4.765-6.548,1.341-18.903-1.213-26.77c-2.465-7.59-14.749-13.958-14.749-22.37c0-8.412,12.284-14.78,14.749-22.37 c2.554-7.867-3.552-20.222,1.213-26.77c4.813-6.614,18.483-4.599,25.096-9.412c6.548-4.765,8.83-18.414,16.696-20.968 c7.59-2.465,17.425,7.156,25.837,7.156c8.412,0,18.247-9.62,25.837-7.156c7.867,2.554,10.149,16.203,16.697,20.969 c6.613,4.813,20.283,2.799,25.096,9.413c4.765,6.548-1.341,18.903,1.213,26.77C165.949,294.541,178.234,300.908,178.234,309.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M58.695,335.713c-5.435-7.39-8.645-16.516-8.645-26.392c0-24.627,19.964-44.592,44.592-44.592s44.592,19.964,44.592,44.592 s-19.964,44.592-44.592,44.592c-2.815,0-5.568-0.261-8.238-0.759"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 473.434,
    y1: 84.324,
    x2: 473.434,
    y2: 84.324
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 69.625,
    y1: 84.324,
    x2: 69.625,
    y2: 84.324
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 473.402,
    y1: 332.53,
    x2: 473.402,
    y2: 332.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate9865117);
export default __webpack_public_path__ + "static/media/certificate_9865117.3e7829b72826310d232811dd8668a1ed.svg";
export { ForwardRef as ReactComponent };